exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-a6c2cbd6] .el-scrollbar__wrap{overflow-x:hidden;padding-right:0.20833rem;box-sizing:border-box;max-height:2.08333rem}\n", ""]);

// exports
